import { render, staticRenderFns } from "./TalkRoomRegist.vue?vue&type=template&id=79dbe6f9"
import script from "./TalkRoomRegist.vue?vue&type=script&lang=js"
export * from "./TalkRoomRegist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports